import React, { useEffect, useState } from 'react';
import clx from "classnames";
import { useModal } from '../../../../stores/useModal';
import {Empty} from '../../../shared/empty'
import { Spinner } from '../../../shared/spinner';
import {motion} from 'framer-motion'
import supportStore from '../../../../stores/useSupport';
import { Action } from '../../../shared/action';

const Conversations = () => {
  const {messages, primaryColor, detail} = supportStore(state=>state)

  const [msgs, setMessages] = useState([]);
  const {open} = useModal(state=>state)

   const preview = (path) => {
    open({type:'preview', values:{path} })
   }

   const [delay, setDelay] = useState(false)

   useEffect(()=>{
    setTimeout(() => setDelay(true) , 1500)
    setDelay(false)
   },[messages])


  return (
    <ul class="conversations lg:grid flex flex-col gap-2 md:gap-2 p-6 lg:p-6 " >
          {messages.map((user,i)=>{
            
            return (
              
              <li key={`message-${i}`} className={clx(user.me && 'flex justify-end')} >
                <div class="">
                  <div>
                    <div className={clx('flex gap-3', user.me && 'items-start flex-row-reverse')} >
                      <img
                        src={user.avatar}
                        class="h-14 w-14"
                      />
                      <div class="w-full">
                        <div className={clx("flex gap-2 items-center font-medium", user.me && 'flex-row-reverse')}  >
                          <p>{user.name}</p>
                          <small className="text-xm text-gray-500">{user.date}</small>
                        </div>
                        <ul class="chain grid gap-3 mt-2">
                          {user.messages.map((message,i)=>{
                            let string = typeof message == 'string'
                            return string ?  (
                              <motion.li
                                  animate={{x: user.me ? [-25,0] : [25,0] }}
                                  transition={{ ease: "easeIn" }}
                                  className='group'
                                >
                                  <div className={clx(user.me && 'group w-full dark:text-white flex flex-col items-end ')} >
                                    {/* Held for tailwind compiler */}
                                    <div className='bg-blue-600 bg-green-500 bg-yelow-500 bg-red-500 bg-zinc-500 dark:bg-blue-600 dark:bg-green-500 dark:bg-yellow-500 dark:bg-red-500 dark:bg-zinc-500'></div>
                                  <div
                                    class={clx(
                                     'relative p-2 px-6 dark:bg-[#1e2126] rounded-b-full w-fit', 
                                     user.me ? `bg-${primaryColor}-${primaryColor=='blue'?'600':'500'} 
                                                dark:bg-${primaryColor}-${primaryColor=='blue'?'600':'500'} 
                                                bg-blue-600--dark:bg-blue-600 text-white rounded-s-full` :
                                                'bg-[#f7f7f6] bg-gray-200 rounded-e-full',
                                    
                                    )}
                                  >
                                    <p>
                                      {message.split(' ').map(item=>{
                                        if(item.match('@Richard')){
                                          return <span class="text-blue-700 dark:text-blue-400 bg-blue-500/30 py-[1px] px-1 mx-[1px] rounded-md cursor-pointer mr-2" >{item}</span>
                                        }
                                        if(item.match('@Jimmy')){
                                          return <span class="font-bold text-blue-500 cursor-pointer mr-2">{item}</span>
                                        }
                                        return item + ` `
                                      })}
                                    </p>
                                    <Action me={user.me} />
                                  </div>
                                </div>
                              </motion.li>
                            ): (
                              <></>
                            )
                          })}
                          <li class="sm:w-96">
                            <div class="grid grid-cols-6 gap-3 w-full">
                                {user.images?.map((image,i)=>(
                                  <div
                                    onClick={()=>preview(image)}
                                    class={clx(
                                      i==0 && 'col-span-4',
                                      i==1 && 'col-span-2',
                                      `dark:bg-gray-600 bg-gray-600 h-32 rounded-md cursor-pointer rounded-md overflow-hidden`
                                    )}
                                  >
                                    <img
                                      src={image.path}
                                      class="h-full w-full object-cover bg-center"
                                    />
                                  </div>
                                ))}
                              
                            </div>
                            <ul class="flex gap-2 mt-2">
                              {user.reactions?.map((emoji,key)=>(
                                <li
                                class="px-2 rounded-full cursor-pointer dark:border-gray-700 border-gray-200 border-2 flex items-center"
                              >
                                <p class="">{emoji.emoji}</p>
                                {emoji.count}
                              </li>
                              ))}
                            </ul>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            )
          })}

          {messages.length==0 && delay && <Empty /> }
          {messages.length==0 && !delay && <Spinner /> }
    </ul>
  )
}

export default Conversations;